import { gql } from '@apollo/client';

export const GENERATE_GOOD_DEAL_ARTICLE_IA = gql`
  mutation GenerateGoodDealArticle($productUrl: URL!, $brandKey: BrandKey!) {
    generateAIGoodDealArticle(productUrl: $productUrl, brandKey: $brandKey) {
      status
    }
  }
`;
